import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import confettiAnim from "./confetti.json"; // Downloaded JSON from LottieFiles
import apiClient from "../../utils/apiClient";
import { useAuth } from "../../contexts/authContext";  // import the auth context hook

export default function WelcomeSplash() {
  //const [user, setUser] = useState({ name: "Nick" }); // Replace with actual fetch
  const navigate = useNavigate();
  const { name } = useAuth();  // get the login function from context

  return (
    <div className="relative min-h-[calc(100vh-60px)] flex items-center justify-center overflow-hidden">
      {/* Blurred background image */}
      <img
        src="../assets/family-kitchen.jpeg"
        alt="Kitchen background"
        className="absolute w-full h-full object-cover blur-sm opacity-40"
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/30"></div>

      {/* Confetti */}
      <div className="absolute inset-0 pointer-events-none">
        <Lottie animationData={confettiAnim} loop={false} />
      </div>

      {/* Foreground content */}
      <motion.div
        className="relative text-center text-white z-10 px-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      >
        <motion.h1
          className="text-4xl sm:text-5xl font-extrabold mb-4"
          initial={{ scale: 0.95 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.6 }}
        >
          Welcome to Sous, {name}.
        </motion.h1>
        <motion.p
          className="text-lg sm:text-xl mb-8 max-w-xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
        >
          Say goodbye to boring meals and hello to reduced food waste, easy meal planning and recipes personalised for you.
        </motion.p>
        <motion.button
          onClick={() => navigate("/onboard/about-you")}
          className="bg-sage text-white text-lg px-6 py-3 rounded-xl shadow-lg hover:bg-sagedark transition"
          whileTap={{ scale: 0.95 }}
        >
          Let's go!
        </motion.button>
      </motion.div>
    </div>
  );
}
